export const FETCH_ALL = "FETCH_ALL";
export const CREATE = "CREATE";
export const FETCH_RENTAL = "FETCH_RENTAL";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH";
export const FETCH_USER_BOOKINGS = "FETCH_USER_BOOKINGS";
export const START_LOADING = "START_LOADING";
export const END_LOADING = "END_LOADING";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESSFUL = "LOGIN_SUCCESSFUL";
export const REGISTRATION_FAILURE = "REGISTRATION_FAILURE";
export const MAKE_PAYMENT = "MAKE_PAYMENT";
export const PAYMENT_DONE = "PAYMENT_DONE";
export const PAYMENT_IS_PENDING = "PAYMENT_IS_PENDING";
export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const SUBSCRIBE = "SUBSCRIBE";
export const SUBSCRIPTION_SUCCESSFUL = "SUBSCRIPTION_SUCCESSFUL";
export const SUBSCRIPTION_DONE = "SUBSCRIPTION_DONE";
